import React from "react";
import { cn } from "../../../../lib/utils";
import ButtonV2 from "../../button/v2";

interface ITextButtonCellProps {
  value?: string;
  onClick?: () => void;
  className?: string;
  buttonClassName?: string;
  variant?:
    | "text"
    | "outline"
    | "primary"
    | "secondary"
    | "ghost"
    | "destructive"
    | "link";
  size?: "sm" | "md" | "lg";
}

const TextButtonCell: React.FC<ITextButtonCellProps> = ({
  value,
  onClick,
  className,
  buttonClassName,
  variant = "text",
  size = "sm",
}) => {
  return (
    <div className={cn("", className)}>
      <ButtonV2
        variant={variant}
        size={size}
        className={cn("text-[#3551F3]", buttonClassName)}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        {value || "Click"}
      </ButtonV2>
    </div>
  );
};

export default TextButtonCell;
